const stepathonModelSchema = ({data}) => {
  const stepathonType = {
    team: 'Team',
    individual: 'Individual',
    milestone: 'Milestone',
  };
  let stepathon_type = stepathonType[data.stepathon_type?.toLowerCase()]
  let start_date = data.start_date
  let end_date = data.end_date
  return (
    <tr className='text-gray-600' key={data.id} >
      <td className='pl-3 pr-4 py-4' style={{width: '20%'}}>{data.name}</td>
      <td className='pl-3 pr-4 py-4' style={{width: '20%'}}> {stepathon_type} </td>
       <td className='pl-3 pr-4 py-4' style={{width: '30%'}}>{start_date}</td>
       <td className='pl-3 pr-4 py-4' style={{width: '30%'}}>{end_date}</td>
    </tr>  
  )
}

export default stepathonModelSchema